<partial-loading-indicator #loadingIndicator>

  <div class="change-password_header">
    <span>{{'components.change-password-page.change_password_page_title' | l10n}}</span>
  </div>

  <div class="change-password_body">
    @switch (state) {
      @case (ChangePasswordPageState.FORM) {
        <form [formGroup]="form" (submit)="submit($event)">
          <div class="change-password_instructions">{{'components.change-password-page.form_instructions' | l10n}}</div>
          @if (isAuthorized) {
            <div class="change-password_field">
              <input type="password" class="change-password_field_input"
                [placeholder]="'components.change-password-page.form_input_current_password' | l10n"
                [formControl]="form.controls.currentPassword"
                autofocus
                materialInput />
            </div>
          }
          <div class="change-password_field">
            <input type="password" class="change-password_field_input"
              [placeholder]="'components.change-password-page.form_input_password' | l10n"
              [formControl]="form.controls.password"
              [autofocus]="!isAuthorized"
              materialInput />
          </div>
          <div class="change-password_field">
            <input type="password" class="change-password_field_input"
              [placeholder]="'components.change-password-page.form_input_confirm_password' | l10n"
              [formControl]="form.controls.repeatPassword"
              materialInput />
          </div>
          @if (isTwoFACodeRequired) {
            <div class="change-password_field">
              <input type="password" class="change-password_field_input"
                [placeholder]="'components.change-password-page.form_input_code' | l10n"
                [formControl]="form.controls.twoFACode"
                [autofocus]="doFocusTwoFACode"
                materialInput />
            </div>
          }
          <div class="change-password_error-message">
            {{formErrors?.commonError | l10n}}
          </div>
          <div class="change-password_footer-wrapper">
            <button class="change-password_submit-button" type="submit" [disabled]="loadingIndicator.getLoadingState()">
              <span class="change-password_submit-button_text">{{'components.change-password-page.submit_form_button' | l10n}}</span>
            </button>
            <ng-container *ngTemplateOutlet="backToButton"></ng-container>
          </div>
        </form>
      }
      @case (ChangePasswordPageState.SUCCESS) {
        <div class="change-password_success-info">
          {{'components.change-password-page.success_text_paragraph_1' | l10n}}
        </div>
        <div class="change-password_success-info">
          {{'components.change-password-page.success_text_paragraph_2' | l10n}}
        </div>
        <div class="change-password_submit-wrapper">
          <ng-container *ngTemplateOutlet="backToButton"></ng-container>
        </div>
      }
      @case (ChangePasswordPageState.ERROR) {
        <div class="change-password_error-info">
          {{'components.change-password-page.response_common_error' | l10n}}
        </div>
        <div class="change-password_submit-wrapper">
          <ng-container *ngTemplateOutlet="backToButton"></ng-container>
        </div>
      }
    }
  </div>

</partial-loading-indicator>

<ng-template #backToButton>
  <div class="change-password_back-link-wrapper">
    <a class="change-password_back-link" [routerLink]="backButton.routerLink">{{ backButton.buttonText | l10n}}</a>
  </div>
</ng-template>
